<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "CRM",
      text: "CRM",
      status: '',
      search_keyword: '',
      data: [],
      roles: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
    };
  },

  computed: {
   text1(){
    return `Subscriptions (${this.pagination.total})`;
   }, 
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },

  mounted(){ 
   
  }, 

  methods: {
   
    async subscriptions(page = 1) {
     this.setLoading(true);
     try{
      const params = {
       page,
       status: this.status || '', 
       search_keyword: this.search_keyword.trim() || '' 
      };
      const query_string = new URLSearchParams(params).toString();
      const response = await axios.get(`/subscriptions?${query_string}`);
      this.data = response.data.data.data;
      this.pagination = {
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        last_page: response.data.data.last_page,
        total: response.data.data.total,
        links: response.data.data.links
      };
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    changePage(url){
     if (!url) return;
     const page = new URL(url).searchParams.get("page");
     this.subscriptions(page);
    },

   clearFilter(){
    this.status = '';
    this.search_keyword = '';
    this.subscriptions();
   },
    
  },
};
</script>

<style scoped>
/* ── FILTER ── */
.s-filter-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; cursor: pointer;
  transition: border-color .15s; min-width: 130px;
}
.s-filter-select:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
 
.s-search-wrap {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  overflow: hidden; background: #fff;
}
.s-search-wrap:focus-within { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
.s-search-input {
  border: none; outline: none; height: 34px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  width: 190px; background: transparent;
}
.s-search-btn {
  width: 36px; height: 36px; background: #0f172a;
  border: none; color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; transition: background .15s;
}
.s-search-btn:hover { background: #1e293b; }
 
.s-clear-btn {
  width: 34px; height: 34px; background: #fff0f3;
  border: 1.5px solid #fecdd3; border-radius: 8px;
  color: #f43f5e; font-size: 15px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.s-clear-btn:hover { background: #f43f5e; color: #fff; border-color: #f43f5e; }
 
/* ── STATUS BADGE ── */
.s-status {
  font-size: 10.5px; font-weight: 600;
  border-radius: 20px; padding: 3px 10px;
  display: inline-block;
}
.s-status.active     { background: #f0fdf4; color: #16a34a; border: 1px solid #86efac; }
.s-status.paused     { background: #fffbeb; color: #d97706; border: 1px solid #fde68a; }
.s-status.cancelled  { background: #fff0f3; color: #f43f5e; border: 1px solid #fecdd3; }
.s-status.completed  { background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; }
 
/* ── SUBSCRIPTION LINK ── */
.s-sub-link {
  font-size: 13px; font-weight: 600; color: #0f172a;
  text-decoration: none; transition: color .15s;
}
.s-sub-link:hover { color: #6366f1; }
 
/* ── COMPANY NAME ── */
.s-company {
  font-size: 13px; font-weight: 600; color: #0f172a;
}
.s-company-sub {
  font-size: 11px; color: #94a3b8; margin-top: 1px;
}
 
/* ── DURATION BADGE ── */
.s-duration {
  font-size: 11px; color: #475569;
  background: #f1f5f9; border: 1px solid #e2e8f0;
  border-radius: 20px; padding: 2px 10px;
  display: inline-block; font-weight: 500;
}
 
/* ── PRICE ── */
.s-price { font-size: 13px; font-weight: 700; color: #16a34a; }
 
/* ── DATE RANGE ── */
.s-date-start { font-size: 12px; font-weight: 600; color: #16a34a; }
.s-date-end   { font-size: 12px; font-weight: 600; color: #f43f5e; }
.s-date-sep   { font-size: 11px; color: #cbd5e1; margin: 0 4px; }
</style>
 
<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
 
<div class="page-wrapper">
  <div class="content">
 
    <!-- Breadcrumb -->
    <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <breadcrumb :title="title" :text="text" :text1="text1" />
    </div>
 
    <!-- Main Card -->
    <div class="card border-0 shadow-sm" style="border-radius:14px; overflow:hidden;">
 
      <!-- Card Header -->
      <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
        <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
          Subscription List
          <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
        </h5>
 
        <!-- Filters -->
        <div class="d-flex align-items-center flex-wrap gap-2">
 
          <!-- Clear -->
          <button v-if="search_keyword !== '' || status !== ''" class="s-clear-btn" @click="clearFilter()" title="Clear filters">
            <i class="ti ti-filter-x"></i>
          </button>
 
          <!-- Status -->
          <select class="s-filter-select" v-model="status" @change="subscriptions">
            <option value="">Status</option>
            <option value="active">Active</option>
            <option value="paused">Paused</option>
            <option value="cancelled">Cancelled</option>
            <option value="completed">Completed</option>
          </select>
 
          <!-- Search -->
          <div class="s-search-wrap">
            <input type="text" class="s-search-input" v-model="search_keyword" placeholder="Search..." />
            <button class="s-search-btn" type="button" @click="subscriptions()">
              <i class="ti ti-search"></i>
            </button>
          </div>
 
        </div>
      </div>
 
      <!-- Card Body -->
      <div class="card-body card-table-wrapper">
 
        <div class="table-responsive" v-if="data.length">
          <table class="card-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Company</th>
                <th>Subscription</th>
                <th>Duration</th>
                <th>Price</th>
                <th>Start / End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in data" :key="row.id">
 
                <!-- Serial -->
                <td style="color:#94a3b8; font-size:11px; font-weight:600; width:42px;">
                  {{ serialNo + index + 1 }}.
                </td>
 
                <!-- Company -->
                <td>
                  <div class="s-company">{{ row.customer?.company_name }}</div>
                </td>
 
                <!-- Subscription Name -->
                <td>
                  <a href="javascript:void(0);"
                    class="s-sub-link"
                    data-bs-toggle="modal"
                    data-bs-target="#subscription_view_modal"
                    @click="$refs.subscriptionModal.edit(row)">
                    {{ row.subscription_name }}
                  </a>
                </td>
 
                <!-- Duration -->
                <td>
                  <span class="s-duration">{{ row.duration }} {{ row.duration_type }}</span>
                </td>
 
                <!-- Price -->
                <td>
                  <span class="s-price">{{ row.price }}</span>
                </td>
 
                <!-- Start / End Date -->
                <td>
                  <span class="s-date-start">{{ $formatDate(row.start_date) }}</span>
                  <span class="s-date-sep">→</span>
                  <span class="s-date-end">{{ $formatDate(row.end_date) }}</span>
                </td>
 
              </tr>
            </tbody>
          </table>
        </div>
 
        <!-- Empty State -->
        <div v-else style="text-align:center; padding:48px; color:#94a3b8;">
          <i class="ti ti-refresh" style="font-size:36px; display:block; margin-bottom:10px; opacity:.35;"></i>
          No records found.
        </div>
 
        <!-- Pagination -->
        <nav v-if="pagination.links.length > 3" class="px-2 py-3">
          <ul class="card-pagination">
            <li v-for="(link, index) in pagination.links" :key="index"
              :class="{ active: link.active, disabled: !link.url }">
              <a href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
            </li>
          </ul>
        </nav>
 
      </div>
    </div>
    <!-- /Main Card -->
 
  </div>
 
  <app-footer></app-footer>
</div>
 
<subscription-modal :roles="roles" ref="subscriptionModal" @updated="subscriptions"></subscription-modal>
</template>